import { useCallback } from "react";
import { Button, Card, Stack, Text } from "@shopify/polaris";
import { openModal } from "../../../../../store/features/modal.js";
import { OPEN_MODAL_CREATE_ACTION } from "../../../../../constants/modalTypes.js";
import styles from './ActionCard.module.css'
import { useAppDispatch } from "../../../../../hooks/redux.js";
const ActionCard = ({ src, title, description, type }) => {
  const dispatch = useAppDispatch();

  const handleChooseAction = useCallback(() => {
    dispatch(openModal({ modalType: OPEN_MODAL_CREATE_ACTION, modalData: { actionType: type } }));
  }, [type]);

  return (
    <div className={styles.cardWrapper}>
      <Card
        sectioned
      >
        <Card.Section>
            <Stack vertical distribution='center' alignment='center'>
              <div className={styles.imageWrapper}>
                <img src={src}></img>
              </div>
              <Text variant="headingMd" as="p" alignment="center">
                {title}
              </Text>
              <div className={styles.description}>
                <Text variant="bodyMd" as="p" alignment="center">
                  {description}
                </Text>
              </div>
              <Button
                primary
                onClick={handleChooseAction}
              >
                Choose and continue
              </Button>
            </Stack>
        </Card.Section>
      </Card>
    </div>
  );
};

export default ActionCard;